import { render, staticRenderFns } from "./MyCalendar.vue?vue&type=template&id=c0c45100&scoped=true&"
import script from "./MyCalendar.vue?vue&type=script&lang=js&"
export * from "./MyCalendar.vue?vue&type=script&lang=js&"
import style0 from "./MyCalendar.vue?vue&type=style&index=0&id=c0c45100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c45100",
  null
  
)

export default component.exports